export default __webpack_public_path__ + "static/SaxvonRegular-1698da324fae51249a5d71460e415baf.woff";